import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'About Us', path: '/about' },
      { label: 'Our Services', path: '/services' },
      { label: 'Blog', path: '/blog' },
      { label: 'Contact', path: '/contact' }
    ],
    services: [
      { label: 'Residential Solar', path: '/services' },
      { label: 'Commercial Solar', path: '/services' },
      { label: 'Battery Storage', path: '/services' },
      { label: 'Maintenance', path: '/services' }
    ]
  };

  const socialLinks = [
    { icon: Facebook, url: 'https://www.facebook.com/profile.php?id=61582804771105', label: 'Facebook' },
    { icon: Instagram, url: 'https://www.instagram.com/energy.spectrum/', label: 'Instagram' },
    { icon: Linkedin, url: 'https://www.linkedin.com/company/109582365', label: 'LinkedIn' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_solarpanel-site-1/artifacts/585zqnxr_ENERGY%20%28Logo%29_20251025_175049_0000.png" 
              alt="Energy Spectrum - Clean Energy Without Limits" 
              className="footer-logo"
            />
            <p className="body-small footer-tagline">
              Clean energy without limits. A new company powered by 12 years of solar industry expertise.
            </p>
            <div className="footer-social">
              {socialLinks.map((social, index) => {
                const IconComponent = social.icon;
                return (
                  <a 
                    key={index}
                    href={social.url}
                    className="social-link"
                    aria-label={social.label}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <IconComponent size={20} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Company Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Company</h3>
            <ul className="footer-links">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Services</h3>
            <ul className="footer-links">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-heading">Contact Us</h3>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <Phone size={16} />
                <a href="tel:0404844257" className="footer-link">0404 844 257</a>
              </li>
              <li className="footer-contact-item">
                <Mail size={16} />
                <a href="mailto:info@energyspectrum.com.au" className="footer-link">
                  info@energyspectrum.com.au
                </a>
              </li>
              <li className="footer-contact-item">
                <MapPin size={16} />
                <span className="body-small">Leppington, NSW 2179</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="body-small footer-copyright">
            © {currentYear} Energy Spectrum. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <Link to="/privacy" className="footer-link body-small">Privacy Policy</Link>
            <span className="footer-divider">|</span>
            <Link to="/terms" className="footer-link body-small">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;